export const SHOW_NAVBAR = 'SHOW_NAVBAR';
export const SHOW_MENU = 'SHOW_MENU';
export const START_TRANSITION = 'START_TRANSITION';
export const END_TRANSITION = 'END_TRANSITION';
export const SELECT_SERVICE = 'SELECT_SERVICE';
export const SELECT_PORTFOLIO = 'SELECT_PORTFOLIO';
export const LOAD_SERVICES = 'LOAD_SERVICES';
export const LOAD_SKILLSETS = 'LOAD_SKILLSETS';
export const LOAD_SPECIALISMS = 'LOAD_SPECIALISMS';
export const GET_SERVICE_BY_TYPE = 'GET_SERVICE_BY_TYPE';
export const PAGE_CHANGE = 'PAGE_CHANGE';
export const CLEAR_STATE = 'CLEAR_STATE';
export const LOAD_SERVICE_SUCCESS = 'LOAD_SERVICE_SUCCESS';
export const LOAD_SERVICE_PORTFOLIOS_SUCCESS = 'LOAD_SERVICE_PORTFOLIOS_SUCCESS';
export const LOAD_SERVICE_CLIENTS_SUCCESS = 'LOAD_SERVICE_CLIENTS_SUCCESS';
export const LOAD_POSTS_SUCCESS = 'LOAD_POSTS_SUCCESS';
export const LOAD_POST_SUCCESS = 'LOAD_POST_SUCCESS';
export const LOAD_ABOUT_SUCCESS = 'LOAD_ABOUT_SUCCESS';
export const LOAD_TERMS_SUCCESS = 'LOAD_TERMS_SUCCESS';
export const LOAD_PRIVACY_SUCCESS = 'LOAD_PRIVACY_SUCCESS';
export const CLEAR_SELECTED_SERVICE = 'CLEAR_SELECTED_SERVICE';
export const LOADING_POSTS = 'LOADING_POSTS';
export const LOADING_POSTS_BY_SERVICE = 'LOADING_POSTS_BY_SERVICE';
export const LOADING_POST = 'LOADING_POST';
export const LOADING_ABOUT = 'LOADING_ABOUT';
export const LOADING_PORTFOLIO = 'LOADING_PORTFOLIO';
// export const SEND_START_PROJECT = 'SEND_START_PROJECT';
export const SENDING_START_PROJECT = 'SENDING_START_PROJECT';
export const SENT_START_PROJECT = 'SENT_START_PROJECT';
export const SENDING_ENQUIRY = 'SENDING_ENQUIRY';
export const SENT_ENQUIRY = 'SENT_ENQUIRY';
export const SENDING_FEEDBACK = 'SENDING_FEEDBACK';
export const SENT_FEEDBACK = 'SENT_FEEDBACK';
export const SEARCHING_PORTFOLIOS = 'SEARCHING_PORTFOLIOS';
export const SEARCHING_PORTFOLIOS_SUCCESS = 'SEARCHING_PORTFOLIOS_SUCCESS';
export const USER_LOGGING_IN = 'USER_LOGGING_IN';
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
export const USER_LOGIN_FAILED = 'USER_LOGIN_FAILED';
export const USER_LOGOUT = 'USER_LOGOUT';
export const CHECK_USER = 'CHECK_USER';



/** WEBPACK FOOTER **
 ** ./src/js/actions/actionTypes.js
 **/